import React, { PropsWithChildren } from 'react';
import Box from "@mui/material/Box";
import { StyledHeaderBox, StyledTypography, StyledTypographySpan } from "./styled-components";
import { ChangeEventHandler, ReactNode } from "react";
import Stack from "@mui/material/Stack";
import SearchComponent from "components/Search/searchComponent";
import Button from "@mui/material/Button";

interface IPageContentContainerProps {
  pageName: string;
  searchValue: string;
  filteredResultsCount?: number;
  resetFilterClicked?: () => void;
  searchValueChanged: ChangeEventHandler<HTMLInputElement>;
}

function createComponentWithChildren() {
  return (props: PropsWithChildren) => <>{props.children}</>;
}

export const PageContentAddNew = createComponentWithChildren();
export const PageContentFilter = createComponentWithChildren();
export const PageContentTable = createComponentWithChildren();

export const PageContentContainer: React.FC<PropsWithChildren<IPageContentContainerProps>> = (props) => {
  let addNewRegion: ReactNode;
  let filterRegion: ReactNode;
  let tableRegion: ReactNode;

  React.Children.forEach(props.children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type === PageContentAddNew) {
      addNewRegion = child;
    } else if (child.type === PageContentFilter) {
      filterRegion = child;
    } else if (child.type === PageContentTable) {
      tableRegion = child;
    }
  });

  return (
    <Box sx={{ width: '1', height: 1, display: 'flex', flexDirection: 'column' }}>
      <StyledHeaderBox>
        <StyledTypography>{props.pageName}</StyledTypography>
        {addNewRegion}
      </StyledHeaderBox>
      <Stack sx={{marginTop: 2}} direction='row' justifyContent='start' alignItems='center' spacing={2} flexWrap='nowrap'>
        <SearchComponent handleInputChange={props.searchValueChanged} searchValue={props.searchValue} />
        {filterRegion}
        {filterRegion && <Button variant='text' size='small' onClick={props.resetFilterClicked} sx={{ marginBottom: '8px' }}>
          Reset filter
        </Button>}
      </Stack>
      {filterRegion && <StyledTypographySpan sx={{marginTop: 2}}>Showing {`${props.filteredResultsCount || 0}`} results</StyledTypographySpan>}
      
      <Box sx={{flex:1, minHeight: 0, marginTop: 2}}>
        {tableRegion}
      </Box>
    </Box>
  );
}